import { render, staticRenderFns } from "./our_services.vue?vue&type=template&id=063060b2&scoped=true&"
import script from "./our_services.vue?vue&type=script&lang=js&"
export * from "./our_services.vue?vue&type=script&lang=js&"
import style0 from "./our_services.vue?vue&type=style&index=0&id=063060b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063060b2",
  null
  
)

export default component.exports